module.exports = __webpack_public_path__ + "static/img/game-type-cjxxl.a82e9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-type-cjxxl.png
// module id = sElN
// module chunks = 1